module.exports = __webpack_public_path__ + "fonts/Amaranth-Bold.675180e6.ttf";